import { defineComponent } from "vue"

export default defineComponent({
  props: ["operation_perc"] as const,
  render() {
    return (
      <div class="d-flex align-items-center border-0 p-0">
        {this.operation_perc > 0 && (
          <>{parseInt(String(this.operation_perc * 100), 10)}%</>
        )}
        <span class="mx-1 spinner-border spinner-border-sm" />
      </div>
    )
  },
})
